require('./bootstrap');
import 'lazysizes';

window.Vue = require('vue');

Vue.component('website-pricing-slider', require('./components/WebsitePricingSlider.vue').default);

window.events = new Vue();

let vueApp = new Vue({

    el: '.vue-app',

    data: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    }
});

document.addEventListener("DOMContentLoaded",function(){

    /*
     * Push the footer to the bottom if required - it's on a 10 millisecond delay
     * to avoid the flicker of the element moving (And sometimes it gets it wrong
     * if it doesn't hang on for a millisecond or three).
     */
    setTimeout(function(){

        let footer         = document.getElementById('footer');
        let documentHeight = window.innerHeight;

        if ((footer.getBoundingClientRect().top + footer.offsetHeight) < documentHeight) {

            footer.style.marginTop = (documentHeight - (footer.getBoundingClientRect().top + footer.offsetHeight)) + 'px';
            footer.style.visibility = 'visible';

        } else {

            footer.style.visibility = 'visible';
        }

    }, 10);


    if (document.getElementById('login-form')) {
        document.getElementById('login-form').onsubmit = function (e) {
            processReCaptcha('login-form', 'google-recaptcha-data', e);
        };
    }


    if (document.getElementById('register-form')) {
        document.getElementById('register-form').onsubmit = function (e) {
            processReCaptcha('register-form', 'google-recaptcha-data', e);
        };
    }


    if (document.getElementById('contact-form')) {
        document.getElementById('contact-form').onsubmit = function (e) {
            processReCaptcha('contact-form', 'google-recaptcha-data', e);
        };
    }


    function processReCaptcha(formId, hiddenField, e) {

        e.preventDefault();

        let siteKey = document.querySelector('meta[name="recaptcha-key"]').content;

        grecaptcha.ready(function() {
            grecaptcha.execute(siteKey, { action: 'login' }).then(function(token) {
                document.getElementById(hiddenField).value = token;
                document.getElementById(formId).submit();
            });
        });
    }
});
